import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static values = {
    chosenClasses: Array,
    labelChosenClasses: Array,
    default: String,
    current: { type: String, default: '' }
  }

  static targets = ['item']

  declare chosenClassesValue: string[]
  declare labelChosenClassesValue: string[]
  declare defaultValue: string
  declare currentValue: string

  declare readonly itemTargets: HTMLAnchorElement[]

  connect() {
    if (this.currentValue === '') {
      this.currentValue =
        window.location.pathname + (window.location.hash || `#${this.defaultValue}`)
    }
  }

  anchorClicked({ params: { url } }: { params: { url: string } }) {
    this.currentValue = url
  }

  currentValueChanged(currentValue: string) {
    this.itemTargets.forEach((target: HTMLAnchorElement) => {
      const url = target.getAttribute('href')
      this.#toggleClasses(target, url === currentValue)
    })
    const container = document.getElementById(window.location.hash.replace('#', ''))
    container?.scrollIntoView()
  }

  #toggleClasses(target: HTMLAnchorElement, shouldSelect: boolean) {
    const parent = target.parentElement
    if (!parent) return

    this.chosenClassesValue.forEach((className: string) => {
      this.#toggleClass(parent, shouldSelect, className)
    })

    this.labelChosenClassesValue.forEach((className: string) => {
      this.#toggleClass(target, shouldSelect, className)
    })
  }

  #toggleClass(target: HTMLElement, shouldSelect: boolean, className: string) {
    if (shouldSelect) {
      target.classList.add(className)
    } else {
      target.classList.remove(className)
    }
  }
}
